import {RootState} from '../../app/store';
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit';
import {miniSerializeError} from '../../app/utils/reducerUtils';

interface LayoutState {
    drawerOpen: boolean;
    drawerFilter: string;
    error?: Error;
}

const initialState: LayoutState = {
    drawerOpen: true,
    drawerFilter: '',
};

export const handleError = createAsyncThunk('layout/error', async (error: Error, {getState,rejectWithValue}) => {
    throw rejectWithValue(miniSerializeError(error));
});

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        toggleDrawer: (state, action: PayloadAction<boolean | void>) => {
            state.drawerOpen = typeof action.payload === 'boolean' ? action.payload : !state.drawerOpen;
        },
        filterDrawer: (state, action: PayloadAction<string>) => {
            state.drawerFilter = action.payload;
        },
        clearError: (state) => {
            state.error = undefined;
        },
    },
    extraReducers: builder => {
        // TODO: Refactor - put into a separate reducer?
        builder.addMatcher<any>(action => {
            return /\/rejected$/.test(action.type);
        }, (state, action) => {
            if (action.meta.condition) {
                return;
            }
            if(action.payload)
                state.error = action.payload;
            else
                state.error = action.error;
        });
    }
});

export const {
    toggleDrawer,
    filterDrawer,
    clearError,
} = layoutSlice.actions;

export const selectOpen = (state: RootState) => state.layout.drawerOpen;
export const selectFilter = (state: RootState) => state.layout.drawerFilter;
export default layoutSlice.reducer;
